module.exports = __webpack_public_path__ + "static/media/65 - Shintaro Sakamoto - Let's Dance Raw.90bdfad6.mp3";